var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item"},[_c('p',{domProps:{"textContent":_vm._s(_vm.errorMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }